import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: relative;
  width: 100%;
  height: auto;
  bottom: 4%;
  left: -4%;

  .cls-1 {
    fill: ${({ $fill }) => $fill};
  }
`;

const Headshape = ({ fill }) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="325.475"
      height="509.141"
      viewBox="0 0 325.475 509.141"
      $fill={fill}
    >
      <g id="head" transform="translate(-199.663 -163.057)">
        <g id="neck">
          <path
            id="Path_264"
            data-name="Path 264"
            className="cls-1"
            d="M331.035,668.272c117.833,27.8,134.245-101.2,129.291-100.357-20.354,3.446-19.417-5.715-19.417-5.715.363-17.92-1.169-47.914-.909-60.746s.515-22.887.733-29.739c.175-5.613.34-9.032.487-10.1-.173.468-.586,1.338-1.261,2.652-.487.944-1.1,2.107-1.838,3.467-.72,1.4-1.7,2.75-2.739,4.415q-.792,1.224-1.679,2.587c-.607.874-1.284,1.713-1.974,2.633l-2.182,2.851c-.771.96-1.625,1.837-2.485,2.813a66.146,66.146,0,0,1-12.611,11.053A53.772,53.772,0,0,1,397.5,501.8a57.331,57.331,0,0,1-20.514,1.469l-2.756-.3-2.788-.476c-1.878-.267-3.757-.811-5.676-1.225a98.509,98.509,0,0,1-11.66-3.958,108.3,108.3,0,0,1-11.964-5.939q-3.02-1.732-6.053-3.751c-1-.659-2.057-1.4-3-2.075l-.246-.16q.069,4.809.136,9.739.135,7.656.345,15.5c.277,10.456-1.445,18-1.037,28.875s.3,18.137.848,29.356c.272,5.609-25.762,8.7-25.433,14.371C307.926,587.031,256.54,650.7,331.035,668.272Z"
          />
          <path
            id="Path_265"
            data-name="Path 265"
            d="M442.085,562.914c-.345-6.931.415-26.278.45-29.3.267-23.3,1.036-48.839,1.185-72.141,0-.058-.012-.107-.015-.163a1.246,1.246,0,0,0-.013-.137,2.536,2.536,0,0,0-4.431-1.246,2.242,2.242,0,0,0-.177.253c-.007.012-.016.02-.022.032l-.076.131c-.014.028-.033.052-.046.081-11.6,20.491-29.513,38.032-54.376,38.217-15.63.116-30.837-5.966-43.872-14.236a77.983,77.983,0,0,1-8.2-5.807,2.533,2.533,0,0,0-4.267,1.768c-.08,29.337.968,58.724,2.388,88.046-.076.031-.146.059-.236.1-.747.3-6.526,7.779-25.01,10.079a67.406,67.406,0,0,1-12.832,3.581c1.319.018,2.722.028,4.2-.044,2.029-.051,5.884-.367,8.88-.452,14.582-.414,24.6-9.165,25.184-9.453q.339,6.828.7,13.651c.355,6.744-.147,2.461.37,9.2a38.6,38.6,0,0,0,.544,5.615c1.721-3.985,3.129-17.309,2.422-31.3-1.785-35.344-1.539-48.457-1.59-83.86,22.186,16.539,53.738,24.831,78.879,10.935,11.045-6.1,19.653-15.53,26.543-25.988-.108,18.251.476,70.94.244,82.766.43,4.012-1.25,13.689,4.9,16.194A14.98,14.98,0,0,1,442.085,562.914Z"
          />
        </g>
        <g id="head-2">
          <path
            id="Path_266"
            data-name="Path 266"
            className="cls-1"
            d="M387.18,167.9c-92.022-9.955-196.7,27.306-184.656,190.9,8.462,114.978,71.8,155.1,95.871,170.055,9.212,5.725,28.208,5.379,41.1,3.375C418.74,519.9,470.3,475.473,484.67,452.813c25.912-40.839,23.467-57.087,32.583-91.129,19.907-74.335-18-194.262-159.832-196.054"
          />
          <g id="Group_221" data-name="Group 221">
            <path
              id="Path_267"
              data-name="Path 267"
              d="M387.742,165.329c-31.58-3.362-64.455-1.46-94.47,9.664-30.314,11.234-55.919,32.167-71.74,60.79-21.745,39.34-24.479,87.139-20.109,131.083,4.271,42.964,17.65,85.394,44.686,119.363A179.973,179.973,0,0,0,276.27,516c7.854,6.128,17.017,13.716,26.484,17.064,10.864,3.841,23.586,3.2,34.818,1.752a242.59,242.59,0,0,0,39.663-8.806,252.421,252.421,0,0,0,63.97-29.649c14.151-9.218,27.78-19.979,38.838-32.887,12.964-15.133,22.627-34.5,28.638-53.49,2.875-9.082,5.749-18.427,7.718-27.74,1.976-9.345,3.628-18.531,5.551-27.88a160.66,160.66,0,0,0,2.7-44.354c-2.443-32.487-14.059-64.241-34.487-89.579-24.307-30.151-59.784-48.036-97.369-54.329a232.406,232.406,0,0,0-34.8-3.041c-3.058-.047-3.059,4.756,0,4.8,40.244.625,81.1,11.276,112.022,38.438,24.41,21.444,40.421,51.069,46.979,82.939a164.868,164.868,0,0,1,3.015,44.288c-1.111,16.425-4.922,31.974-8.3,48C507.391,402,500.82,420.973,490.484,439.3a132.519,132.519,0,0,1-29.862,36.653C426.335,505.4,380.9,524.845,336.3,530.17c-10.92,1.3-24.616,2.361-34.761-2.8a109.645,109.645,0,0,1-11-6.938,184.867,184.867,0,0,1-27.25-22.19c-26.441-26.233-43.162-60.433-51.485-96.7a304.066,304.066,0,0,1-7.118-77.8c.7-21.146,3.778-42.342,10.7-62.366,10.855-31.388,31.875-57.748,60.978-73.519,27.137-14.706,58.52-19.773,89.034-19.165,7.47.149,14.925.653,22.354,1.444,3.037.323,3.014-4.483,0-4.8Z"
            />
          </g>
        </g>
      </g>
    </StyledSvg>
  );
};

Headshape.propTypes = {
  fill: PropTypes.string
};

export default React.memo(
  Headshape,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
